import { useAuth } from '@/components/providers/auth-provider'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'

// import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

interface RootContext {
  auth: ReturnType<typeof useAuth> | undefined
}

// https://www.youtube.com/watch?v=fpXOT8SNTpY
// according to this dude, this is where we place our providers
export const Route = createRootRouteWithContext<RootContext>()({
  component: () => (
    <div
      className="font-sans antialiased overflow-y-hidden"
      style={{
        // fontFamily: 'var(--font-geist-sans)',
        fontFamily: 'var(--font-inter)',
      }}
    >
      {/* <AllProviders> */}
      <Outlet />
      {/* <TanStackRouterDevtools /> */}
      {/* </AllProviders> */}
    </div>
  ),
  errorComponent: ({ error, reset }) => {
    console.log('>>> inside errorComponent')
    console.log({ error })
    console.log({ errorMessage: error.message })
    console.log({ errorCause: error.cause })
    if (typeof error.stack === 'string') {
      console.log({ errorStack: error.stack.split('\n') })
    } else {
      console.log({ errorStack: error.stack })
    }
    return (
      <div className="flex items-center justify-center min-h-screen w-full bg-background">
        <div className="w-full max-w-md p-6">
          <div className="rounded-lg border bg-card text-card-foreground shadow-sm p-8 flex flex-col items-center gap-4">
            <h1 className="text-2xl font-bold">Something went wrong</h1>
            <pre className="whitespace-pre-wrap break-words text-sm bg-muted rounded p-4 w-full max-h-48 overflow-auto border text-destructive">
              {error.message}
            </pre>
            <button
              className="cursor-pointer mt-4 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
              onClick={reset}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    )
  },
})
